import type { Recipient } from "../types";

/** Consent lives on the recipient, postOnly on each patient — the backend flags a recipient as
 *  post-only once *every* patient under it is (backend utils/postOnly.ts), and then refuses
 *  digital consent outreach (email/SMS/QR). */
export function isRecipientPostOnly(recipient: Pick<Recipient, "postOnly"> | null | undefined): boolean {
    return recipient?.postOnly === true;
}
